var _rect, _g, _g2, _g3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSitePreviewinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 172,
    viewBox: "0 0 275 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 275,
    height: 172,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 36,
    width: 73,
    height: 49,
    fill: "#ECF2F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 90,
    width: 72,
    height: 6,
    fill: "#ECF2F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 101,
    width: 72,
    height: 6,
    fill: "#ECF2F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 112,
    width: 54,
    height: 6,
    fill: "#ECF2F5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 36,
    width: 73,
    height: 49,
    fill: "#ECF2F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 90,
    width: 72,
    height: 6,
    fill: "#ECF2F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 101,
    width: 72,
    height: 6,
    fill: "#ECF2F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 112,
    width: 54,
    height: 6,
    fill: "#ECF2F5"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 36,
    width: 73,
    height: 49,
    fill: "#ECF2F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 90,
    width: 72,
    height: 6,
    fill: "#ECF2F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 101,
    width: 72,
    height: 6,
    fill: "#ECF2F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 112,
    width: 54,
    height: 6,
    fill: "#ECF2F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 82,
    fill: "white",
    transform: "translate(16 36)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 82,
    fill: "white",
    transform: "translate(101 36)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 82,
    fill: "white",
    transform: "translate(186 36)"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjc1IiBoZWlnaHQ9IjE3MiIgdmlld0JveD0iMCAwIDI3NSAxNzIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIyNzUiIGhlaWdodD0iMTcyIiBmaWxsPSJ3aGl0ZSIvPgo8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDApIj4KPHJlY3QgeD0iMTYiIHk9IjM2IiB3aWR0aD0iNzMiIGhlaWdodD0iNDkiIGZpbGw9IiNFQ0YyRjUiLz4KPHJlY3QgeD0iMTYiIHk9IjkwIiB3aWR0aD0iNzIiIGhlaWdodD0iNiIgZmlsbD0iI0VDRjJGNSIvPgo8cmVjdCB4PSIxNiIgeT0iMTAxIiB3aWR0aD0iNzIiIGhlaWdodD0iNiIgZmlsbD0iI0VDRjJGNSIvPgo8cmVjdCB4PSIxNiIgeT0iMTEyIiB3aWR0aD0iNTQiIGhlaWdodD0iNiIgZmlsbD0iI0VDRjJGNSIvPgo8L2c+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMSkiPgo8cmVjdCB4PSIxMDEiIHk9IjM2IiB3aWR0aD0iNzMiIGhlaWdodD0iNDkiIGZpbGw9IiNFQ0YyRjUiLz4KPHJlY3QgeD0iMTAxIiB5PSI5MCIgd2lkdGg9IjcyIiBoZWlnaHQ9IjYiIGZpbGw9IiNFQ0YyRjUiLz4KPHJlY3QgeD0iMTAxIiB5PSIxMDEiIHdpZHRoPSI3MiIgaGVpZ2h0PSI2IiBmaWxsPSIjRUNGMkY1Ii8+CjxyZWN0IHg9IjEwMSIgeT0iMTEyIiB3aWR0aD0iNTQiIGhlaWdodD0iNiIgZmlsbD0iI0VDRjJGNSIvPgo8L2c+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMikiPgo8cmVjdCB4PSIxODYiIHk9IjM2IiB3aWR0aD0iNzMiIGhlaWdodD0iNDkiIGZpbGw9IiNFQ0YyRjUiLz4KPHJlY3QgeD0iMTg2IiB5PSI5MCIgd2lkdGg9IjcyIiBoZWlnaHQ9IjYiIGZpbGw9IiNFQ0YyRjUiLz4KPHJlY3QgeD0iMTg2IiB5PSIxMDEiIHdpZHRoPSI3MiIgaGVpZ2h0PSI2IiBmaWxsPSIjRUNGMkY1Ii8+CjxyZWN0IHg9IjE4NiIgeT0iMTEyIiB3aWR0aD0iNTQiIGhlaWdodD0iNiIgZmlsbD0iI0VDRjJGNSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwIj4KPHJlY3Qgd2lkdGg9IjczIiBoZWlnaHQ9IjgyIiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTYgMzYpIi8+CjwvY2xpcFBhdGg+CjxjbGlwUGF0aCBpZD0iY2xpcDEiPgo8cmVjdCB3aWR0aD0iNzMiIGhlaWdodD0iODIiIGZpbGw9IndoaXRlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMDEgMzYpIi8+CjwvY2xpcFBhdGg+CjxjbGlwUGF0aCBpZD0iY2xpcDIiPgo8cmVjdCB3aWR0aD0iNzMiIGhlaWdodD0iODIiIGZpbGw9IndoaXRlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxODYgMzYpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";
export { SvgSitePreviewinline as ReactComponent };